import { Routes } from '@angular/router';
import { UiEditorComponent } from './dashboard/ui-editor/ui-editor.component';
import { LoginComponent } from './auth/login/login.component';
import { ResetPasswordComponent } from './auth/reset-passwoard/reset-password.component';
import { AcceptInviteComponent } from './auth/accept-invite/accept-invite.component';
import { authGuard } from './services/auth.guard';
import { BlankComponent } from './auth/blank/blank.component';
import { ErrorComponent } from './settings/integrations/error.component';
import { SuccessComponent } from './settings/integrations/success.component';

/**
 * THE ROUTES A LIVE APP HAS. The editor build serves these AND its own (app.routes.ts); the Live build
 * serves ONLY these (app.routes.runtime.ts, swapped in by angular.json's runtime fileReplacements).
 *
 * ⚠ Anything imported here ships inside every published app — web, Android and iPhone. A builder
 * screen added here puts the app builder back into customer apps, which App Store guideline 2.3.1
 * rejects (hidden features). Builder-only routes belong in app.routes.ts.
 * `npm run check-runtime-artifact` fails the Live build if editor code reaches it.
 */
export const RUNTIME_ROUTES: Routes = [
  // A Live app's pages are drawn by UiEditorComponent in its isRuntime mode. Generated function code
  // runs with `this` bound to it, so its methods are the function ABI — it is not replaceable by a
  // slimmer page component without auditing every published function. Its editor-only children are
  // stubbed in the Live build instead (see angular.json runtime fileReplacements).
  { path: 'ui-editor', canActivate: [authGuard], component: UiEditorComponent },
  // Artifact pre-auth landing (Track 4): the project's landingPage IS the auth gate, rendered
  // by the same UiEditorComponent (landing branch in startComponent). UNGUARDED — anonymous visitors
  // must reach it. Only meaningful in the artifact (isRuntime); the editor never routes here.
  { path: 'landing', component: UiEditorComponent },
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'resetPassword',
    component: ResetPasswordComponent,
  }, {
    path: 'accept-invite',
    component: AcceptInviteComponent,
  }, {
    path: 'blank',
    component: BlankComponent,
  },
  // Meta OAuth lands here: leads.function.ts redirects to CLIENT_APP_URL, which is a runtime host.
  {
    path: 'settings/integrations',
    children: [
      { path: 'meta=error', component: ErrorComponent },
      { path: 'meta=connected', component: SuccessComponent },
    ],
  },
];
